import isEqual from "fast-deep-equal";
import {
  AutoRecipeDefaultsRead,
  AutoRecipeParameters,
} from "store/api/generatedApi";
import { useDefaultDraft } from "./useDefaultDraft";

const createDraft = (source: AutoRecipeDefaultsRead) =>
  source.effective.parameters;
const normaliseDraft = (
  source: AutoRecipeDefaultsRead,
  proposed: AutoRecipeParameters
) => (isEqual(source.effective.parameters, proposed) ? null : proposed);
const sourcesMatch = (
  first: AutoRecipeDefaultsRead,
  second: AutoRecipeDefaultsRead
) => isEqual(first.context, second.context);

export const useAutoRecipeDraft = (defaults: AutoRecipeDefaultsRead) =>
  useDefaultDraft({
    defaultSource: defaults,
    createDraft,
    normaliseDraft,
    sourcesMatch,
  });
